import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Redirect } from "react-router";
import PageTitle from "@my-dld/components/PageTitle";
import Strings from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { OwnerCommitteeProps, TrackIndex } from "./index";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { exToMessage } from "@eres/ssoapi/api";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { getEmiratesID } from "@10x/sso";
import { OwnerCommitteeDocument } from "../../ownercommitteeapi/entities";


interface Props extends OwnerCommitteeProps {

}

interface State {
	property: AssetCard;
}

class OwnerCommitteeSteps extends Component<Props, State> {
	apiHandler: any;
	apiExHandler: any;
	propertyId: any;

	constructor( props: OwnerCommitteeProps ) {
		super( props );
		this.state = {
			property: props.property,
		};
	}

	render() {
		const { property } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		return <>
			<PageTitle title={ Strings.owner_committee_reg } paths={ [ DashboardBCItem ] }/>
			<div className="row">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<div className="row mb-4">
						<div className="col-md-12">
							<p className="alert alert-info">
								{ Strings.steps_board_members }
							</p>
							<ul className="arrow-list">
								<li>
									{ Strings.request_add_text }
								</li>
								<li>
									{ Strings.upload_documents_text }
								</li>
								<li>
									{ Strings.submit_final_request }
								</li>
							</ul>
						</div>
						<div className="col-md-12">
							<button
								onClick={ this.onProceed } type="button" className="btn btn_1 btn_style1"
								id="ownerCommitteRequestAdd">
								{ Strings.request_to_add }
							</button>
						</div>
					</div>
				</div>
			</div>
		</>;
	}

	private getPostObject() {
		let req = {
			"propertyId": this.props.property.propertyId,
			"ownerNumber": TabuProfile.getParticipantNumber(),
			"emiratesId": getEmiratesID()
		};
		return req;
	}

	private validateProperty() {
		showLoading();
		OwnerCommitteeApi.validatePropertyOwner( this.getPostObject() ).then( ( response: any ) => {
			hideLoading();
			if ( response.response.errorList && response.response.errorList.length > 0 ) {
				showErrorMessage( OwnerCommitteeApi.getValidationError( response.response.errorList ) );
			} else {
				let documents: OwnerCommitteeDocument[] = [];
				response.response.requireDocuments.forEach( ( item: any ) => {
					let doc: OwnerCommitteeDocument = { name: item.name.englishName, documentId: 0, arabicName: "", englishName: "", docs: [] };
					doc.arabicName = item.name.arabicName ? item.name.arabicName : "";
					doc.englishName = item.name.englishName ? item.name.englishName : "";
					doc.maxSize = item.maxSize;
					doc.isMandatory = item.isMandatory;
					doc.documentId = item.documentId;
					documents.push( doc );
				} );
				if ( response.response.isValid === true ) {
					this.props.setDocuments( documents, response.response.isDewaRequire, () => {
						this.props.onNext( TrackIndex.COMMITTEE_DOCUMENTS );
					} );
				}
			}
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	private onProceed = () => {
		this.validateProperty();
	};
}

export default OwnerCommitteeSteps;
